const usePropsOverride = <T>(originalProps: T, overrides?: Partial<T>): T => {
  if (!overrides) return originalProps;

  const newProps = { ...originalProps, ...overrides };
  return newProps;
};

export default usePropsOverride;
